/* Core & libraries */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/* Helpers, constants, custom methods, internal libraries */
import { useTeamService } from '../../../services/teamService';
import { useAnalytics } from "../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../constants/appConstants";

/* Components */
import MembersGrid from './membersGrid';

/* Styles */
import { usePeopleService } from '../../../services/peopleService';


const MembersTab = (props) => {
  const { teamId, teamDetails } = props;
  const location = useLocation();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/bookings')
      ? 1
      : new URLSearchParams(location.search).get('page') || 1;
    return {
      page: +initialPage,
    };
  });

  const { membersList, getMembersList, deleteMember } = useTeamService();
  const { updatePeople, gridActionPermision } = usePeopleService();
  const { initAnalytics } = useAnalytics();

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["teamDetails"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    getMembersList(gridOptions, teamId);
  }, [gridOptions]);

  useEffect(() => {
    const pageFromURL = location.pathname.includes('/bookings')
      ? 1
      : new URLSearchParams(location.search).get('page') || 1;
    if (+pageFromURL !== gridOptions.page) {
      setGridOptions({ ...gridOptions, page: pageFromURL });
    }
  }, [location.search]);

  const handleDeleteMember = async (entity) => {
    const response = await deleteMember(entity);
    if (response) {
      getMembersList(gridOptions, teamId);
      return true;
    }
    return false;
  };

  const handleUpdatePeople = async (values) => {
    const response = await updatePeople(values);
    if (response) {
      getMembersList(gridOptions, teamId);
      return true;
    }
    return false;
  };

  return (
    <MembersGrid
      members={membersList}
      gridOptions={gridOptions}
      setGridOptions={setGridOptions}
      deleteMember={handleDeleteMember}
      teamDetails={teamDetails}
      updatePeople={handleUpdatePeople}
      gridActionPermision={gridActionPermision}
    />
  );
};

export default MembersTab;
